module.exports = __webpack_public_path__ + "static/MT_Process-04.5fe6d316.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/process-icons/MT_Process-04.png
// module id = 1501
// module chunks = 214286880276331